






















import { Component, Vue } from "vue-property-decorator";
import { getClientInfo } from "@/data/repository/ClientRepository";
import { ProjectManagement } from "@/data/models/Client";

/**
 * The IRES wordmark shown at the right-hand end of the app bar (Cockpit and Overview).
 *
 * Owns its own vertical centring: it is dropped into toolbar portals next to icon buttons,
 * and must not depend on what else happens to be in that row. See the style block.
 */
@Component
export default class AppBarLogoComponent extends Vue {
  clientInfo = getClientInfo();

  /** "Office", or "HyDry" wording for clients that only manage devices. */
  get projectManagementText() {
    const projectManagement = this.clientInfo?.projectManagement;

    if (projectManagement === ProjectManagement.DEVICES_ONLY_WEBSITE) {
      return this.$t("overview.devicesOnlyWebsite").toString();
    }

    return this.$t("overview.office").toString();
  }
}
